{
  "en": {
    "documentManagement": {
      "validationDeleteMessage": "Your file has been deleted",
      "deleteErrorMessage": "An error occurred while deleting documents",
      "reportDocumentError": "At least one of the documents you're trying to delete is a report. You can't delete reports.",
      "downloadError": "An error occurred while downloading the document",
      "topicCreated": "Topic created successfully",
      "document_update_missing_uuid": "Document UUID is missing. Cannot update document."
    }
  },
  "fr": {
    "documentManagement": {
      "validationDeleteMessage": "Votre ou vos fichiers ont été supprimés",
      "deleteErrorMessage": "Une erreur est survenue pendant la suppression de vos documents",
      "reportDocumentError": "Au moins un des documents que vous essayez de supprimer est un rapport. Il est impossible de supprimer un rapport.",
      "downloadError": "Une erreur est survenue lors du téléchargement du document",
      "topicCreated": "Thème créé avec succès",
      "document_update_missing_uuid": "L'UUID du document est manquant. Impossible de mettre à jour le document."
    }
  },
  "nl": {
    "documentManagement": {
      "validationDeleteMessage": "Uw bestand(en) zijn verwijderd",
      "deleteErrorMessage": "Er is een fout opgetreden bij het verwijderen van uw documenten",
      "reportDocumentError": "Tenminste één van de documenten die u probeert te verwijderen is een rapport. Een rapport kan niet worden verwijderd.",
      "downloadError": "Er is een fout opgetreden bij het downloaden van het document",
      "topicCreated": "Onderwerp succesvol aangemaakt",
      "document_update_missing_uuid": "Document UUID ontbreekt. Kan document niet bijwerken."
    }
  }
}
